import { render, staticRenderFns } from "./overrides.vue?vue&type=template&id=a21d03a4&scoped=true&lang=html"
import script from "./overrides.vue?vue&type=script&lang=js"
export * from "./overrides.vue?vue&type=script&lang=js"
import style0 from "./overrides.vue?vue&type=style&index=0&id=a21d03a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21d03a4",
  null
  
)

export default component.exports